<section>
  <div>
    <h3
      class="mt-0"
      [ngClass]="{'text-align-center': isMobile()}">Guten Tag, {{ therapist()?.fullNameWithTitle }}</h3>
  </div>

  <div
    id="client-card"
    class="sana-card"
    (click)="cardClicked()">

    <div class="row g-3">
      <div class="col">
        <sana-tp-client-search-field></sana-tp-client-search-field>
      </div>

      <!--<div class="col-auto">
        <p-button
          (onClick)="addClient()"
          severity="primary"
          fluid="true"
          [label]="(isMobile$ | async) ? '' : 'Patient anlegen'"
          icon="pi pi-plus-circle"
          data-cy="sana-tp-start-page-createClientButton" />
      </div>-->
    </div>

    <div
      id="client-list-wrapper"
      class="mt-3">
      <sana-tp-client-list></sana-tp-client-list>
    </div>
  </div>
</section>

